"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _breakpoints = require("../../utils/breakpoints");

var _getSourceSetValue = _interopRequireDefault(require("../getSourceSetValue"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getSource(breakpoint, props) {
  var _props$breakpoint, _props$breakpoint2;

  var currentBreakpoint = _breakpoints.breakpoints.indexOf(breakpoint);

  var sourceSet = (_props$breakpoint = props[breakpoint]) === null || _props$breakpoint === void 0 ? void 0 : _props$breakpoint.srcSet;
  var src = (_props$breakpoint2 = props[breakpoint]) === null || _props$breakpoint2 === void 0 ? void 0 : _props$breakpoint2.src;
  var nextBreakpoint = _breakpoints.breakpoints[currentBreakpoint - 1]; // If neither then go the next breakpoint

  if (!sourceSet && !src && nextBreakpoint) {
    return getSource(nextBreakpoint, props);
  } // If the breakpoint has no sourceSet but has src


  if (!sourceSet && src) return src;

  if (sourceSet) {
    return Object.keys(sourceSet).map(function (size) {
      return (0, _getSourceSetValue["default"])(sourceSet[size], size);
    }).filter(Boolean).join(', ');
  }

  return null;
}

var _default = getSource;
exports["default"] = _default;
//# sourceMappingURL=getSource.js.map